// src/pages/Profile.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../pages/Profile.css';
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";

const Profile = () => {
  const [firstName, setFirstName]             = useState('');
  const [lastName, setLastName]               = useState('');
  const [email, setEmail]                     = useState('');
  const [phoneNumber, setPhoneNumber]         = useState('');
  const [estateName, setEstateName]           = useState('');
  const [address, setAddress]                 = useState('');
  const [membershipNumber, setMembershipNumber] = useState('');
  const [registrationDate, setRegistrationDate] = useState(''); 
  const [isEditable, setIsEditable]           = useState(false);
  const [buttonText, setButtonText]           = useState('Edit Profile');
  const [showCancel, setShowCancel]           = useState(false);

  const auth = getAuth();
  const firestore = getFirestore();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;
    const q = query(
      collection(firestore, "users"),
      where("uid", "==", user.uid)
    );

    (async () => {
      try {
        const snap = await getDocs(q);
        if (snap.empty) {
          console.warn("No user doc found");
          return;
        }
        // Assuming exactly one
        const docData = snap.docs[0].data();
        setFirstName(docData.firstName || '');
        setLastName(docData.lastName || '');
        setEmail(docData.email || '');
        setPhoneNumber(docData.phoneNumber || '');
        setEstateName(docData.estateName || '');
        setAddress(docData.address || '');
        setMembershipNumber(docData.membershipNumber || '');

        // registrationDate is a Firestore Timestamp
        if (docData.registrationDate && docData.registrationDate.toDate) {
          setRegistrationDate(
            docData.registrationDate
              .toDate()
              .toLocaleDateString()
          );
        } else {
          setRegistrationDate('N/A');
        }
      } catch (err) {
        console.error("Error fetching user doc", err);
      }
    })();
  }, [auth, firestore]);

  const handleEditModeToggle = () => {
    setIsEditable(!isEditable);
    setButtonText(isEditable ? 'Edit Profile' : 'Save Changes');
    setShowCancel(!showCancel);
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    if (!isEditable) {
      handleEditModeToggle();
      return;
    }

    const user = auth.currentUser;
    if (!user) return;

    const q =	query(
      collection(firestore, "users"),
      where("uid", "==", user.uid)
    );

    try {
      const snap = await getDocs(q);
      if (snap.empty) {
        toast.error("User document not found");
        return;
      }
      const docRef = snap.docs[0].ref;
      await updateDoc(docRef, {
        firstName,
        lastName,
        phoneNumber,
        estateName,
        address
      });
      toast.success("Profile updated", { autoClose: 2000 });
      handleEditModeToggle();
    } catch (err) {
      console.error("Error updating profile", err);
      toast.error("Failed to update");
    }
  };

  return (
    <div className="page-container">
      <Container>
        <Row>
          <Col md={9}>
            <div className="profile-info-container">
              <h2>My Profile</h2>
              <hr />
              <form
                className="registration-form mt-4"
                onSubmit={handleUpdateProfile}
              >
                <div className="form-group">
                  <label className="form-label">Membership Number</label>
                  <input
                    type="text"
                    className="form-control"
                    value={membershipNumber}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Joined On</label>
                  <input
                    type="text"
                    className="form-control"
                    value={registrationDate}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={phoneNumber}
                    onChange={e => setPhoneNumber(e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Zone</label>
                  <input
                    type="text"
                    className="form-control"
                    value={estateName}
                    onChange={e => setEstateName(e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    value={address}
                    onChange={e => setAddress(e.target.value)}
                    disabled={!isEditable}
                  />
                </div>
                <Button variant="primary" type="submit">
                  {buttonText}
                </Button>
                {showCancel && (
                  <Button
                    variant="danger"
                    className="ml-3"
                    onClick={handleEditModeToggle}
                  >
                    Cancel
                  </Button>
                )}
              </form>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default Profile;
